export enum SignalrConnectionType {
  ValidateOrder,
  SaveUploadedProducts,
  ItemizeSet,
  UpdatePricingOnExpiredQuote,
  EditQuote,
  EditQuoteForCalculateTotals,
  StartGoOnlineSync,
  ReceiveOnlineUpdates,
  ImportQuotesOrOrders,
  GenerateQuote
}
